"use client";

import * as X from "@/ui";
import NonIntlLink from "next/link";

// import HeroDesktopImage from "@/assets/bucket/shipping-hero-desktop.png";
// import HeroMobileImage from "@/assets/bucket/shipping-hero-mobile.png";
import KoreanFlagImage from "@/assets/shipping-korean-flag.svg";
import { useShippingPage } from "@/providers/strapi/content/types/singleTypes/shipping-page";
import ReactMarkdown from "react-markdown";
import clsx from "clsx";


export function HeroSection(props: X.PageProps) {
  // const tr = X.useTranslator<"ko">(props);

  const tagLine = useShippingPage('tagLine');
  const content = useShippingPage('content');
  const cta = useShippingPage('cta');
  const readInKorean = useShippingPage('readInKorean');
  const heroPicture = useShippingPage('heroPicture');
  return (
    <section className="relative w-full">
      {/* <h1 className="xl:text-center text-[36px] xl:text-[64px] [&_strong]:font-semibold leading-tight mx-mobile-margin xl:max-w-5xl xl:mx-auto -mt-8 xl:mt-0">
        {tr({
          en: <>Your purchases in Europe delivered worldwide, <strong>without the VAT</strong></>,
          fr: <>Vos achats en Europe, livrés dans le monde entier… <strong>sans la TVA{X.Nbsp}!</strong></>,
          ko: <>유럽 현지 상품을 면세 혜택과 함께 전 세계로 안전하게 배송해드립니다.</>,
        })}
      </h1> */}
      <ReactMarkdown components={{
        p: ({ ...props }) => <h1 {...props} className="xl:text-center text-[36px] xl:text-[64px] [&_strong]:font-semibold leading-tight mx-mobile-margin xl:max-w-5xl xl:mx-auto -mt-8 xl:mt-0" />,
        h1: ({ ...props }) => <h1 {...props} className="xl:text-center text-[36px] xl:text-[64px] [&_strong]:font-semibold leading-tight mx-mobile-margin xl:max-w-5xl xl:mx-auto -mt-8 xl:mt-0" />,
        h2: ({ ...props }) => <h1 {...props} className="xl:text-center text-[36px] xl:text-[64px] [&_strong]:font-semibold leading-tight mx-mobile-margin xl:max-w-5xl xl:mx-auto -mt-8 xl:mt-0" />,
        h3: ({ ...props }) => <h1 {...props} className="xl:text-center text-[36px] xl:text-[64px] [&_strong]:font-semibold leading-tight mx-mobile-margin xl:max-w-5xl xl:mx-auto -mt-8 xl:mt-0" />,
        h4: ({ ...props }) => <h1 {...props} className="xl:text-center text-[36px] xl:text-[64px] [&_strong]:font-semibold leading-tight mx-mobile-margin xl:max-w-5xl xl:mx-auto -mt-8 xl:mt-0" />,
        h5: ({ ...props }) => <h1 {...props} className="xl:text-center text-[36px] xl:text-[64px] [&_strong]:font-semibold leading-tight mx-mobile-margin xl:max-w-5xl xl:mx-auto -mt-8 xl:mt-0" />,

      }}>
        {tagLine}
        {/* {tr({
          en: tagLine,
          fr: tagLine,
          ko: "현지 상품을 면세 혜택과 함께 전 세계로 안전하게 배송해드립니다.",
          zh: tagLine,
        })} */}
      </ReactMarkdown>

      <div className="my-8 xl:my-10 mx-mobile-margin xl:max-w-4xl xl:mx-auto text-[16px] xl:text-[24px] xl:text-center flex flex-col gap-2 leading-tight">
        {/* <p>
          {tr({
            en: `With Zapptax Shipping, you can shop in Europe, reclaim VAT, and ship your purchases internationally — simply and efficiently.`,
            fr: `Avec Zapptax Shipping, achetez en Europe, récupérez la TVA et expédiez vos biens à l’international, en toute simplicité.`,
            ko: `Zapptax Shipping 을 통해 유럽에서의 쇼핑, VAT 환급, 그리고 전 세계 배송을 한 번에 간편하고 효율적으로 처리할 수 있습니다.`,
          })}

        </p> */}
        <ReactMarkdown
          components={{
            h1: ({ ...props }) => <h2 {...props} />
          }}>
          {content}
        </ReactMarkdown>
      </div>

      <div className="my-10 xl:max-w-content xl:mx-auto relative">
        <div className={X.clsx(
          "absolute xl:relative top-[20px] left-[36px] xl:top-auto xl:left-auto z-10",
          "xl:flex xl:flex-row xl:justify-center xl:gap-4 xl:translate-y-1/2",
        )}>
          <X.Button
            primary desktopLg
            className="X-Open-Intercom"
            // label={tr({
            //   en: cta,
            //   fr: cta,
            //   ko: "문의하기",
            //   zh: ""
            // })}
            label={cta}
          // label={tr({
          //   en: "Contact us",
          //   fr: "Contactez-nous",
          //   ko: "문의하기",
          // })}
          />
        </div>

        {/* <X.Image
          src={HeroDesktopImage}
          alt="Retailers"
          className={X.clsx(X.desktopOnly("block"), "xl:w-full h-auto rounded-xl")}
          priority
        />
        <X.Image
          src={HeroMobileImage}
          alt="Retailers"
          className={X.clsx(X.mobileOnly(), "ml-4 w-full h-auto rounded-l-xl")}
          priority
        /> */}
        <div className="w-full  min-h-[290px] xl:min-h-[475px] relative z-0">
          <X.Image
            src={heroPicture.url}
            // height={heroPicture.width}
            // width={heroPicture.height}
            fill
            unoptimized
            alt="Retailers"
            // className={"w-full h-auto rounded-xl object-cover"}
            className={clsx([
              'w-full ml-4 ',
              "xl:ml-0",
              'object-cover object-[15%_0%] md:object-[15%_55%] xl:object-[0%_50%]',
              ' rounded-l-xl xl:rounded-xl'
            ])}
            priority
          />
        </div>
        {/* <X.Image
          src={heroPicture.url}
          height={heroPicture.width}
          width={heroPicture.height}
          unoptimized
          alt="Retailers"
          className={X.clsx(X.desktopOnly("block"), "xl:w-full h-auto rounded-xl")}
          priority
        />
        <X.Image
          src={heroPicture.url}
          height={heroPicture.width}
          width={heroPicture.height}
          unoptimized
          alt="Retailers"
          className={X.clsx(X.mobileOnly(), "ml-4 w-full h-auto rounded-l-xl")}
          priority
        /> */}
      </div>

      {props.nonStandardLocale?.code !== "ko" && (
        <NonIntlLink
          href="/ko/shipping"
          hrefLang="ko"
          className={X.clsx(
            X.desktopOnly("flex"), // if removed, add `flex` to the class list below
            "pt-0 -mt-2 -mb-12 flex-row items-center xl:max-w-content xl:mx-auto gap-4 group",
          )}
        >
          <X.Image
            src={KoreanFlagImage}
            alt="Korea"
            className="w-[60px] h-auto"
          />
          <div className="text-[18px] group-hover:opacity-80 group-hover:translate-x-1 transition-all duration-300 transform-gpu">
            <ReactMarkdown>
              {readInKorean + ' - 이 페이지를 한국어로 읽기'}
            </ReactMarkdown>
            {/* {X.when(
              tr({
                en: readInKorean,
                fr: readInKorean,
                ko: undefined,
                zh: ""
              }),
              // tr({
              //   en: `Read this page in Korean`,
              //   fr: `Lire cette page en coréen`,
              //   ko: undefined,
              // }),
              m => `${m} - 이 페이지를 한국어로 읽기`
            )} */}
          </div>
          <X.Icon.ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-300 transform-gpu" />
        </NonIntlLink>
      )}
    </section>
  );
}
